/**
 * HTTPステータス
 */
const HttpResponseStatusCode = {
  /** セッションタイムアウト */
  SESSIONTIMEOUT: 402,
} as const;

type HttpResponseStatusCode = typeof HttpResponseStatusCode[keyof typeof HttpResponseStatusCode];
export default HttpResponseStatusCode;
